var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export function nodeDiagramId(node) {
    var _a, _b, _c, _d, _e;
    var id = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a.diagramId;
    if (id)
        return id;
    if ((_b = node.metadata) === null || _b === void 0 ? void 0 : _b.orgNode) {
        var name_1 = (_c = node.metadata) === null || _c === void 0 ? void 0 : _c.orgName;
        return name_1 ? "org:".concat(name_1) : undefined;
    }
    if (((_d = node.metadata) === null || _d === void 0 ? void 0 : _d.pipelineStatus) !== undefined) {
        return (_e = node.metadata.diagramId) !== null && _e !== void 0 ? _e : undefined;
    }
    return undefined;
}
export function isEditableDiagramNode(node) {
    var _a, _b, _c, _d;
    return !!(((_a = node.metadata) === null || _a === void 0 ? void 0 : _a.diagramId) ||
        ((_b = node.metadata) === null || _b === void 0 ? void 0 : _b.orgNode) ||
        ((_c = node.metadata) === null || _c === void 0 ? void 0 : _c.pipelineStatus) !== undefined ||
        ((_d = node.metadata) === null || _d === void 0 ? void 0 : _d.symbolType));
}
/** Walk diagram tree and collect editable node groups. */
export function collectEditableNodes(root) {
    var out = [];
    var walk = function (parent) {
        var e_1, _a;
        var _b, _c, _d;
        try {
            for (var _e = __values(parent.children), _f = _e.next(); !_f.done; _f = _e.next()) {
                var child = _f.value;
                if ((_b = child.metadata) === null || _b === void 0 ? void 0 : _b.isDiagramHitTarget)
                    continue;
                if ((_c = child.metadata) === null || _c === void 0 ? void 0 : _c.diagramEditorOverlay)
                    continue;
                if (isEditableDiagramNode(child)) {
                    out.push(child);
                }
                if ('children' in child && ((_d = child.children) === null || _d === void 0 ? void 0 : _d.length)) {
                    walk(child);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    walk(root);
    return out;
}
export function findEdgeLayer(root) {
    var e_2, _a;
    var _b, _c;
    try {
        for (var _d = __values(root.children), _e = _d.next(); !_e.done; _e = _d.next()) {
            var child = _e.value;
            if ((_b = child.metadata) === null || _b === void 0 ? void 0 : _b.diagramEdgeLayer)
                return child;
            if (child.zIndex === -10 && child.type === 'group' && !((_c = child.metadata) === null || _c === void 0 ? void 0 : _c.diagramId)) {
                return child;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return undefined;
}
export function collectEdgesFromLayer(edgeLayer) {
    var e_3, _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var edges = [];
    try {
        for (var _q = __values(edgeLayer.children), _r = _q.next(); !_r.done; _r = _q.next()) {
            var child = _r.value;
            var from = (_b = child.metadata) === null || _b === void 0 ? void 0 : _b.edgeFrom;
            var to = (_c = child.metadata) === null || _c === void 0 ? void 0 : _c.edgeTo;
            if (!from || !to)
                continue;
            var rawWp = (_d = child.metadata) === null || _d === void 0 ? void 0 : _d.edgeWaypoints;
            edges.push({
                id: (_f = (_e = child.metadata) === null || _e === void 0 ? void 0 : _e.edgeId) !== null && _f !== void 0 ? _f : "".concat(from, "-").concat(to),
                from: from,
                to: to,
                label: (_g = child.metadata) === null || _g === void 0 ? void 0 : _g.edgeLabel,
                waypoints: Array.isArray(rawWp) ? rawWp.map(function (w) { return ({ x: w.x, y: w.y }); }) : undefined,
                options: {
                    style: (_h = child.metadata) === null || _h === void 0 ? void 0 : _h.edgeStyle,
                    stroke: (_j = child.metadata) === null || _j === void 0 ? void 0 : _j.edgeStroke,
                    strokeWidth: (_k = child.metadata) === null || _k === void 0 ? void 0 : _k.edgeStrokeWidth,
                    glowColor: (_l = child.metadata) === null || _l === void 0 ? void 0 : _l.edgeGlow,
                    arrowEnd: (_m = child.metadata) === null || _m === void 0 ? void 0 : _m.edgeArrowEnd,
                    arrowStart: (_o = child.metadata) === null || _o === void 0 ? void 0 : _o.edgeArrowStart,
                    dash: (_p = child.metadata) === null || _p === void 0 ? void 0 : _p.edgeDash,
                    waypoints: Array.isArray(rawWp) ? rawWp.map(function (w) { return ({ x: w.x, y: w.y }); }) : undefined,
                },
            });
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_r && !_r.done && (_a = _q.return)) _a.call(_q);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return edges;
}
export function extractNodeLabel(node) {
    var e_4, _a;
    var _b, _c;
    try {
        for (var _d = __values(node.children), _e = _d.next(); !_e.done; _e = _d.next()) {
            var child = _e.value;
            if (child.type === 'text' && 'text' in child) {
                var t = child.text;
                if (t && t.trim())
                    return t;
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return (_c = (_b = node.metadata) === null || _b === void 0 ? void 0 : _b.diagramId) !== null && _c !== void 0 ? _c : 'Node';
}
export function buildNodeRecords(nodes) {
    return nodes.map(function (n) {
        var _a;
        return ({
            id: (_a = nodeDiagramId(n)) !== null && _a !== void 0 ? _a : n.id,
            label: extractNodeLabel(n),
        });
    });
}
export function findNodeByDiagramId(root, id) {
    return collectEditableNodes(root).find(function (n) { return nodeDiagramId(n) === id; });
}
export function resolveEditableGroup(hit) {
    var cur = hit;
    while (cur) {
        if (isEditableDiagramNode(cur)) {
            return cur;
        }
        cur = cur.parent;
    }
    return undefined;
}
